<form>
   <div class="sam-form-row">
      <label>{{ 'common.global_settings.titles.language' | translate }}</label>
      <kendo-dropdownlist
         [data]="availableLanguageTypes"
         [value]="currentLanguage$ | async"
         class="k-form-field sam-form-control sam-form-control-full-width"
         [valuePrimitive]="false"
         [valueField]="'value'"
         [textField]="'value'"
         (selectionChange)="changeLanguage($event)"
      >
         <ng-template kendoDropDownListValueTemplate kendoDropDownListItemTemplate let-dataItem>
            {{ dataItem?.translationKey | translate }}
         </ng-template>
      </kendo-dropdownlist>
   </div>

   <div class="sam-form-row">
      <label>{{ 'common.global_settings.titles.theme' | translate }}</label>
      <kendo-dropdownlist
         [disabled]="!(isFeatureEnabled$ | async)"
         [data]="availableThemeTypes"
         [value]="currentTheme$ | async"
         class="k-form-field sam-form-control sam-form-control-full-width"
         [valueField]="'value'"
         [textField]="'value'"
         [valuePrimitive]="false"
         (selectionChange)="changeTheme($event)"
      >
         <ng-template kendoDropDownListValueTemplate kendoDropDownListItemTemplate let-dataItem>
            {{ dataItem?.translationKey | translate }}
         </ng-template>
      </kendo-dropdownlist>
   </div>

   <div class="sam-form-row">
      <label>{{ 'common.global_settings.titles.warn_before_closing_tab' | translate }}</label>
      <div class="k-form-field k-form-field-with-icon sam-form-control sam-form-control-full-width no-border">
         <kendo-switch
            [checked]="warnBeforeClosingTab$ | async"
            (valueChange)="warnBeforeClosingTabChanged($event)"
         ></kendo-switch>
      </div>
   </div>
</form>
